<template>
  <v-dialog
    id="no-shadow"
    v-model="getModel"
    max-width="600"
    :content-class="getAppName()"
    :fullscreen="true"
    :persistent="this.$vuetify.breakpoint.width < breakpoint ? true : false"
    overlay-opacity="0"
    @click:outside="setAppsCookie()"
  >
    <div
      class="apps-modal"
      :class="[getAppName(), { 'no-transparancy': hasMobilePanoramaError }]"
    >
      <language-bar class="language-bar" />
      <div id="container" :class="getAppName()">
        <div id="logo">
          <BaseIcon multiplatform icon="logo" size="115px" />
        </div>

        <div id="main-title">
          <template v-if="appName(HUYGENS)">
            <h1>HUYGENS’</h1>
            <h1>TIJDMACHINE</h1>
          </template>

          <template v-if="appName(DORDRECHT5D)">
            <h1>DORDRECHT<span class="secondary-dordrecht5D">5D</span></h1>
          </template>

          <template v-if="appName(CANALS5D)">
            <h1>CANALS<span class="secondary-canals5D">5D</span></h1>
          </template>
        </div>

        <div id="content-span-1">
          <h2 v-for="description in descriptionLines" :key="description">
            {{ description }}
          </h2>
        </div>

        <button
          v-if="!this.isSmallScreen"
          type="button"
          class="apps-button"
          :class="getAppName()"
          @click="setAppsCookie()"
        >
          <h2 v-if="appName(HUYGENS)">
            {{ $t("apps.huygens.title") }}
          </h2>
          <h2 v-if="appName(DORDRECHT5D)">
            {{ $t("apps.dordrecht5D.title") }}
          </h2>
          <h2 v-if="appName(CANALS5D)">{{ $t("apps.canals5D.title") }}</h2>
        </button>

        <div id="content-span-2">
          <h2 v-for="download in downloadLines" :key="download">
            {{ download }}
          </h2>
        </div>

        <div class="store-icon-container">
          <span class="store-link" @click="openLink(getAppstoreLink())">
            <img :src="require(`@/assets/images/download-appstore@2x.png`)" />
          </span>

          <span class="store-link" @click="openLink(getPlaystoreLink())">
            <img :src="require(`@/assets/images/download-playstore@2x.png`)" />
          </span>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { appIdentifier } from "@/utils/appIdentifier.js";
import constants from "@/utils/constants.js";
import LanguageBar from "@/components/LanguageBar.vue";

export default {
  components: {
    LanguageBar
  },
  data: function() {
    return {
      HUYGENS: constants.HUYGENS,
      DORDRECHT5D: constants.DORDRECHT5D,
      CANALS5D: constants.CANALS5D,
      breakpoint: 750
    };
  },
  computed: {
    hasMobilePanoramaError() {
      return this.$store.state.panoramaError?.includes("panorama is too big");
    },
    getModel() {
      return this.$store.state.showAppsModal;
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.width < this.breakpoint;
    },
    descriptionLines() {
      const locale = this.$i18n.locale;
      const appName = this.getAppName();
      return this.$i18n.messages[locale].apps[appName].description;
    },
    downloadLines() {
      const locale = this.$i18n.locale;
      return this.$i18n.messages[locale].apps.download;
    }
  },
  watch: {
    "$route.meta.allowAppsModal": {
      immediate: true,
      handler(allowAppsModal) {
        const showAppsModal =
          allowAppsModal &&
          (this.isSmallScreen ||
            !document.cookie.match(`SVS=${appIdentifier()}`));

        this.$store.commit(this.$mutations.SHOW_APPS_MODAL, showAppsModal);

        if (!showAppsModal) {
          this.queueShowFeaturedArticles();
        }
      }
    }
  },
  methods: {
    queueShowFeaturedArticles() {
      setTimeout(
        () => this.$store.commit(this.$mutations.SHOW_FEATURED_ARTICLES, true),
        2500
      );
    },
    appName(name) {
      return name == appIdentifier();
    },
    getAppName() {
      return appIdentifier();
    },
    getAppstoreLink() {
      if (appIdentifier() == constants.HUYGENS) {
        return constants.HUYGENS_APPSTORE_LINK;
      }

      if (appIdentifier() == constants.DORDRECHT5D) {
        return constants.DORDRECHT5D_APPSTORE_LINK;
      }

      if (appIdentifier() == constants.CANALS5D) {
        return constants.CANALS5D_APPSTORE_LINK;
      }
    },
    getPlaystoreLink() {
      if (appIdentifier() == constants.HUYGENS) {
        return constants.HUYGENS_PLAYSTORE_LINK;
      }

      if (appIdentifier() == constants.DORDRECHT5D) {
        return constants.DORDRECHT5D_PLAYSTORE_LINK;
      }

      if (appIdentifier() == constants.CANALS5D) {
        return constants.CANALS5D_PLAYSTORE_LINK;
      }
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    setAppsCookie() {
      if (!this.isSmallScreen) {
        const expiringDate = new Date(
          new Date().getTime() + 60 * 60 * 1000 * 24
        ).toGMTString(); //expiring in 24 hours

        document.cookie = `SVS=${appIdentifier()}; expires=${expiringDate}; path=/`;
        this.$store.commit(this.$mutations.SHOW_APPS_MODAL, false);
        this.queueShowFeaturedArticles();
      }
    }
  }
};
</script>

<style lang="scss">
// @import "../styles/base/colors.scss";

.secondary {
  &-dordrecht5D {
    color: $secondary-dordrecht5D;
  }

  &-canals5D {
    color: $secondary-canals5D;
  }
}

.apps-button {
  width: 315px;
  height: 50px;
  margin-bottom: 20px;
  border-radius: 25px;

  &.huygens {
    background: $secondary-huygens;
  }

  &.dordrecht5D {
    background: $secondary-dordrecht5D;
  }

  &.canals5D {
    background: $secondary-canals5D;
  }
}

div.v-dialog {
  border-top-left-radius: 0 !important;
}

.apps-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  overflow: hidden;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background: var(--v-brand-base);
  text-align: center;

  border-top-left-radius: 0;

  &.huygens {
    background-color: rgba($primary-huygens, 0.95) !important;

    &.no-transparancy {
      background-color: rgba($primary-huygens, 1) !important;
    }
  }

  &.dordrecht5D {
    background-color: rgba($primary-dordrecht5D, 0.95) !important;

    &.no-transparancy {
      background-color: rgba($primary-dordrecht5D, 1) !important;
    }
  }

  &.canals5D {
    background-color: rgba($primary-canals5D, 0.95) !important;

    &.no-transparancy {
      background-color: rgba($primary-canals5D, 1) !important;
    }
  }

  h2 {
    font-size: 1.6rem;
  }

  h1,
  h2 {
    font-family: "AWConquerorCarved-One";
    color: $white;
    padding-top: 0;
    margin: 0 0 0 0;
  }

  h1 {
    font-size: 2.2rem;
    line-height: 2.8rem;
    letter-spacing: 2px;
  }

  h2 {
    font-size: 1.1rem;
    line-height: 2.2rem;
    letter-spacing: 1px;

    @media (min-width: 576px) {
      font-size: 1.3rem;
    }
  }

  #container {
    width: 100%;
    height: auto;
    margin: auto;

    #logo {
      margin-top: 0 !important;
    }
  }

  #logo {
    height: 150px;
    width: 100%;
    display: flex;
    flex: 1;
    justify-content: center;
    margin: 45px 0 0px;
  }

  #main-title {
    width: 100%;

    h2 {
      font-size: 2rem;
    }
  }

  #content-span-1 {
    width: 100%;
    padding: 30px 50px;
  }

  #content-span-2 {
    width: 100%;
    padding: 0 50px;
  }

  @media (max-width: 576px) {
    #logo-container {
      display: none;
    }

    #logo {
      height: 140px;
      margin-top: 35px;
    }

    #main-title {
      margin-top: 0px;
    }

    #content-span-1 {
      padding: 25px 30px 20px 30px;
    }
  }

  .store-icon-container {
    display: flex;
    justify-content: center;
    padding: 20px 0;

    .store-icon {
      width: 130px;
      margin: 0 20px;
    }

    img {
      height: 30px;
      margin: 0 25px;
    }

    .store-link {
      cursor: pointer;
    }
  }
}
</style>
